/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip as ReactTooltip } from 'react-tooltip';

import {
    ClosesIcon,
    Excel,
    Filter,
    Pdf,
    Printer,
    Search
  } from "../EntryFile/imagePath";

const Tabletop = ({inputfilter,value, OnChange}) => {
  return (
    <div className="table-top">
      <div className="search-set">
        <div className="search-path">
        </div>
        <div className="search-input">
          <input
            className="form-control form-control-sm search-icon"
            type="search"
            placeholder="Search..."
            value={value || ""}
            onChange={OnChange || null}
          />
          <Link to="#" className="btn btn-searchset">
            <img src={Search} alt="img" />
          </Link>
        </div>
      </div>
      
    </div>
  );
};

export default Tabletop;
